module.exports = __webpack_public_path__ + "static/media/image-14.51541708.jpg";